import { type SelectOption } from '../';

export const pageRowsSelectOptions: SelectOption[] = [
  { value: 10, label: '10 / page' },
  { value: 20, label: '20 / page' },
  { value: 50, label: '50 / page' },
  // Currently we removed the 100 / page option due to the back-end performance issue.
  // This is due to the BSON document size limit, which is 16MB, on the aggregation pipeline with $facet. The nomination resolver exceeded that.
];
